// extracted by mini-css-extract-plugin
module.exports = {"truncatedPropertyText":"UsersSearch_truncatedPropertyText__2HESG","truncatedTableText":"UsersSearch_truncatedTableText__3HL5w"};